import { useGlobalError } from "../../utils/ErrorContext";
import ErrorAlert from "../ErrorAlert/ErrorAlert";

const GlobalErrorModal = () => {
  const { errorState, closeError } = useGlobalError();

  return (
    <ErrorAlert
      open={errorState.isOpen}
      onClose={closeError}
      content={errorState.message}
      buttonText="OK"
    />
  );
};

export default GlobalErrorModal;
